import React from 'react'
import { Performance } from '../Performance'
import { PerformanceEmployee } from '../PerformanceEmployee'

export const PerformanceReports_r = () => {
    return (
        <div className="card">
            <div className="card-header border-bottom">
                <h5 className="card-title mb-0 text-black">Rendimiento</h5>
            </div>
            <div className="card-body">
                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Tiempos</button>
                    </li>
                    <li className="nav-item ms-2" role="presentation">
                        <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Ordenes</button>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <Performance />
                    </div>
                    <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" >
                        <PerformanceEmployee />
                    </div>
                </div>
            </div>
        </div>
    )
}
